/**
 * 서버로 보내야 하는 데이터들의 공통 분모와 공통 로직을 추가 한다.
 * formData를 서버로 보내는 requestbody로 변경 한다.
 */
// eslint-disable-next-line import/prefer-default-export
export class AbsRequestMap {
    /** 서비스 데이터 레이어에서 사용할 데이터 */
    data;
    constructor(form) {
        this.data = form;
    }
}
